// Self-contained apply/dismiss/like handlers built from suggestion data.
//
// These compose the data-driven builders (utils/suggestionActions) with the raw
// API methods (api/optimizations), so a host can apply/dismiss/like a suggestion
// without writing any per-archetype payload logic:
//
//   await applySuggestion(suggestion, { valueAfter, selectedIds, confirmReviewDone });
//
// or execute a request already built by the card:
//
//   await runApplyRequest(applyRequest);

import optimizationsApi from 'api/optimizations';
import {
  buildApplyRequest,
  buildDismissRequest,
  buildLikeRequest,
} from 'utils/suggestionActions';

/** Build the apply request from data and execute it. Returns null for NO_ACTION. */
export async function applySuggestion(suggestion, opts = {}) {
  return runApplyRequest(buildApplyRequest(suggestion, opts));
}

export async function dismissSuggestion(suggestion, opts = {}) {
  return runDismissRequest(buildDismissRequest(suggestion, opts));
}

export async function likeSuggestion(suggestion, opts = {}) {
  const req = buildLikeRequest(suggestion, opts);
  if (!req) return null;
  return optimizationsApi.likeSuggestion(req.id, req.body);
}

/** Execute a pre-built request descriptor ({ id, body }) — e.g. one the card built. */
export async function runApplyRequest(req) {
  if (!req) return null;
  return optimizationsApi.applySuggestion(req.id, req.body);
}

export async function runDismissRequest(req) {
  if (!req) return null;
  return optimizationsApi.dismissSuggestion(req.id, req.body);
}
